/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "channels": {
        "email": {
          "description": "Benachrichtigungen per E-Mail erhalten",
          "key": "E-Mail"
        },
        "inApp": {
          "description": "Benachrichtigungen live in der App erhalten",
          "key": "In der App"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Alle Benachrichtigungen löschen",
        "settingsLabel": "Einstellungen"
      },
      "emptyState": "Sie haben keine Benachrichtigungen",
      "error": {
        "card_title": "Fehler",
        "clear_all_error": "Es konnten nicht alle Benachrichtigungen gelöscht werden.",
        "mark_all_as_read_error": "Es konnten nicht alle Benachrichtigungen als gelesen markiert werden.",
        "mark_as_read_error": "Benachrichtigung konnte nicht als gelesen markiert werden.",
        "network_error": {
          "subtitle": "Versuchen Sie es später noch einmal.",
          "title_main": "Ihre Benachrichtigungen können nicht geladen werden",
          "title_settings": "Ihre Benachrichtigungseinstellungen können nicht geladen werden"
        },
        "preferences_update_error": "Ihre Benachrichtigungseinstellungen können nicht aktualisiert werden. Versuchen Sie es später noch einmal."
      },
      "expand": "Erweitern",
      "mainTitle": "Benachrichtigungen",
      "markAllAsReadLabel": "Alles als gelesen markieren",
      "markAsReadLabel": "Als gelesen markieren",
      "notificationBellAriaLabel": "Mitteilungszentrale",
      "settings": {
        "accountSettings": "Kontoeinstellungen",
        "accountSettingsPrompt": "Sie können dies in {<settingsLink>} ändern",
        "currentEmail": "Ihre aktuelle E-Mail-Adresse für Benachrichtigungen lautet {<email>}",
        "header": "Benachrichtigungseinstellungen",
        "subtitle": "Ihre Benachrichtigungseinstellungen wirken sich nicht auf Systembenachrichtigungen/erinnerungen aus.",
        "title": "Wählen Sie aus, wie Sie benachrichtigt werden möchten."
      },
      "unreadLabel": "Ungelesen"
    }
  },
  {
    "key": "en",
    "content": {
      "channels": {
        "email": {
          "description": "Get notifications via email",
          "key": "Email"
        },
        "inApp": {
          "description": "Get notifications live in-app",
          "key": "In-app"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Clear all notifications",
        "settingsLabel": "Settings"
      },
      "emptyState": "You don't have any notifications",
      "error": {
        "card_title": "Error",
        "clear_all_error": "Could not clear all notifications.",
        "mark_all_as_read_error": "Could not mark all notifications as read.",
        "mark_as_read_error": "Could not mark notification as read.",
        "network_error": {
          "subtitle": "Please try again later.",
          "title_main": "We are unable to load your notifications",
          "title_settings": "We are unable to load your notification settings"
        },
        "preferences_update_error": "We are unable to update your notification settings. Please try again later."
      },
      "expand": "Expand",
      "mainTitle": "Notifications",
      "markAllAsReadLabel": "Mark all as read",
      "markAsReadLabel": "Mark as read",
      "notificationBellAriaLabel": "notification center",
      "settings": {
        "accountSettings": "Account Settings",
        "accountSettingsPrompt": "You can change it in {<settingsLink>}",
        "currentEmail": "Your current email for notifications is {<email>}",
        "header": "Notification settings",
        "subtitle": "System alerts/reminders will not be affected by your notification settings.",
        "title": "Select how you want to be notified."
      },
      "unreadLabel": "Unread"
    }
  },
  {
    "key": "es",
    "content": {
      "channels": {
        "email": {
          "description": "Recibir notificaciones por correo electrónico",
          "key": "Correo electrónico"
        },
        "inApp": {
          "description": "Recibir notificaciones en directo en la aplicación",
          "key": "En la aplicación"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Borrar todas las notificaciones",
        "settingsLabel": "Parámetros"
      },
      "emptyState": "No tiene ninguna notificación",
      "error": {
        "card_title": "Error",
        "clear_all_error": "No se pudieron borrar todas las notificaciones.",
        "mark_all_as_read_error": "No se pudieron marcar todas las notificaciones como leídas.",
        "mark_as_read_error": "No se pudo marcar la notificación como leída.",
        "network_error": {
          "subtitle": "Inténtelo de nuevo más tarde.",
          "title_main": "No podemos cargar sus notificaciones",
          "title_settings": "No podemos cargar los parámetros de notificación"
        },
        "preferences_update_error": "No podemos actualizar los parámetros de notificación. Inténtelo de nuevo más tarde."
      },
      "expand": "Expandir",
      "mainTitle": "Notificaciones",
      "markAllAsReadLabel": "Marcar todo como leído",
      "markAsReadLabel": "Marcar como leído",
      "notificationBellAriaLabel": "centro de notificaciones",
      "settings": {
        "accountSettings": "Parámetros de cuenta",
        "accountSettingsPrompt": "Puede hacer el cambio en {<settingsLink>}",
        "currentEmail": "Su correo electrónico actual para notificaciones es {<email>}",
        "header": "Parámetros de notificaciones",
        "subtitle": "Las alertas/recordatorios del sistema no se verán afectados por los parámetros de notificación.",
        "title": "Seleccione cómo quiere recibir las notificaciones."
      },
      "unreadLabel": "Sin leer"
    }
  },
  {
    "key": "fr",
    "content": {
      "channels": {
        "email": {
          "description": "Réception des notifications par e-mail",
          "key": "E-mail"
        },
        "inApp": {
          "description": "Réception des notifications directement dans l'application",
          "key": "Dans l'application"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Effacer toutes les notifications",
        "settingsLabel": "Paramètres"
      },
      "emptyState": "Vous n'avez aucune notification",
      "error": {
        "card_title": "Erreur",
        "clear_all_error": "Impossible d'effacer toutes les notifications.",
        "mark_all_as_read_error": "Impossible de marquer toutes les notifications comme lues.",
        "mark_as_read_error": "Impossible de marquer la notification comme lue.",
        "network_error": {
          "subtitle": "Réessayez plus tard.",
          "title_main": "Nous ne pouvons pas charger vos notifications",
          "title_settings": "Nous ne pouvons pas charger vos paramètres de notification"
        },
        "preferences_update_error": "Nous ne pouvons pas mettre à jour vos paramètres de notification. Réessayez plus tard."
      },
      "expand": "Développer",
      "mainTitle": "Notifications",
      "markAllAsReadLabel": "Tout marquer comme lu",
      "markAsReadLabel": "Marquer comme lu",
      "notificationBellAriaLabel": "centre de notifications",
      "settings": {
        "accountSettings": "Paramètres de compte",
        "accountSettingsPrompt": "Vous pouvez modifier le paramètre dans {<settingsLink>}",
        "currentEmail": "Votre adresse e-mail actuelle pour recevoir les notifications est {<email>}",
        "header": "Paramètres de notification",
        "subtitle": "Vos paramètres de notification n'affectent pas les alertes ou rappels système.",
        "title": "Sélectionnez le mode de notification souhaité."
      },
      "unreadLabel": "Non lu"
    }
  },
  {
    "key": "it",
    "content": {
      "channels": {
        "email": {
          "description": "Ricevi notifiche via e-mail",
          "key": "E-mail"
        },
        "inApp": {
          "description": "Ricevi notifiche in tempo reale nell'app",
          "key": "Nell'app"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Cancella tutte le notifiche",
        "settingsLabel": "Impostazioni"
      },
      "emptyState": "Non hai ricevuto alcuna notifica",
      "error": {
        "card_title": "Errore",
        "clear_all_error": "Impossibile cancellare tutte le notifiche.",
        "mark_all_as_read_error": "Impossibile contrassegnare tutte le notifiche come lette.",
        "mark_as_read_error": "Impossibile contrassegnare la notifica come letta.",
        "network_error": {
          "subtitle": "Riprovare più tardi.",
          "title_main": "Non siamo in grado di caricare le tue notifiche",
          "title_settings": "Non siamo in grado di caricare le impostazioni di notifica"
        },
        "preferences_update_error": "Non siamo in grado di aggiornare le impostazioni di notifica. Riprovare più tardi."
      },
      "expand": "Espandi",
      "mainTitle": "Notifiche",
      "markAllAsReadLabel": "Contrassegna tutto come letto",
      "markAsReadLabel": "Contrassegna come letto",
      "notificationBellAriaLabel": "centro notifiche",
      "settings": {
        "accountSettings": "Impostazioni account",
        "accountSettingsPrompt": "È possibile modificarlo in {<settingsLink>}",
        "currentEmail": "L'indirizzo e-mail corrente per le notifiche è {<email>}",
        "header": "Impostazioni di notifica",
        "subtitle": "Gli avvisi/promemoria di sistema non saranno influenzati dalle impostazioni di notifica.",
        "title": "Seleziona la modalità di notifica che desideri."
      },
      "unreadLabel": "Non letto"
    }
  },
  {
    "key": "ja",
    "content": {
      "channels": {
        "email": {
          "description": "メールで通知を受け取る",
          "key": "メール アドレス"
        },
        "inApp": {
          "description": "アプリ内でリアルタイムの通知を受け取る",
          "key": "アプリ内"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "すべての通知を消去する",
        "settingsLabel": "設定"
      },
      "emptyState": "通知はありません",
      "error": {
        "card_title": "エラー",
        "clear_all_error": "すべての通知を消去できませんでした。",
        "mark_all_as_read_error": "すべての通知を既読としてマークできませんでした。",
        "mark_as_read_error": "通知を既読としてマークできませんでした。",
        "network_error": {
          "subtitle": "後で再試行してください。",
          "title_main": "通知を読み込めません",
          "title_settings": "通知設定を読み込めません"
        },
        "preferences_update_error": "通知設定を更新できません。後で再試行してください。"
      },
      "expand": "展開",
      "mainTitle": "通知",
      "markAllAsReadLabel": "すべて既読としてマーク",
      "markAsReadLabel": "既読としてマーク",
      "notificationBellAriaLabel": "通知センター",
      "settings": {
        "accountSettings": "アカウント設定",
        "accountSettingsPrompt": "{<settingsLink>} で変更できます",
        "currentEmail": "現在の通知用メール アドレスは {<email>} です",
        "header": "通知設定",
        "subtitle": "システム アラート/リマインダーは通知設定の影響を受けません。",
        "title": "通知方法を選択します。"
      },
      "unreadLabel": "未読"
    }
  },
  {
    "key": "nl",
    "content": {
      "channels": {
        "email": {
          "description": "Ontvang meldingen via e-mail",
          "key": "E-mail"
        },
        "inApp": {
          "description": "Ontvang meldingen live in de app",
          "key": "In de app"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Wis alle meldingen",
        "settingsLabel": "Instellingen"
      },
      "emptyState": "U hebt geen meldingen",
      "error": {
        "card_title": "Fout",
        "clear_all_error": "Kon niet alle meldingen wissen.",
        "mark_all_as_read_error": "Kon niet alle meldingen als gelezen markeren.",
        "mark_as_read_error": "Kon de melding niet als gelezen markeren.",
        "network_error": {
          "subtitle": "Probeer het later opnieuw.",
          "title_main": "We kunnen uw meldingen niet laden",
          "title_settings": "We kunnen uw meldingsinstellingen niet laden"
        },
        "preferences_update_error": "We kunnen uw meldingsinstellingen niet bijwerken. Probeer het later opnieuw."
      },
      "expand": "Uitvouwen",
      "mainTitle": "Meldingen",
      "markAllAsReadLabel": "Alle als gelezen markeren",
      "markAsReadLabel": "Markeren als gelezen",
      "notificationBellAriaLabel": "berichtencentrum",
      "settings": {
        "accountSettings": "Accountinstellingen",
        "accountSettingsPrompt": "U kunt het wijzigen in {<settingsLink>}",
        "currentEmail": "Uw huidige e-mailadres voor meldingen is {<email>}",
        "header": "Instellingen voor meldingen",
        "subtitle": "Systeemwaarschuwingen/herinneringen worden niet beïnvloed door uw meldingsinstellingen.",
        "title": "Selecteer hoe u op de hoogte wilt worden gehouden."
      },
      "unreadLabel": "Ongelezen"
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "channels": {
        "email": {
          "description": "Receber notificações por email",
          "key": "Email"
        },
        "inApp": {
          "description": "Receber notificações em tempo real no aplicativo",
          "key": "No aplicativo"
        }
      },
      "dropdown": {
        "clearNotificationsLabel": "Limpar todas as notificações",
        "settingsLabel": "Configurações"
      },
      "emptyState": "Você não tem nenhuma notificação",
      "error": {
        "card_title": "Erro",
        "clear_all_error": "Não foi possível limpar todas as notificações.",
        "mark_all_as_read_error": "Não foi possível marcar todas as notificações como lidas.",
        "mark_as_read_error": "Não foi possível marcar a notificação como lida.",
        "network_error": {
          "subtitle": "Tente novamente mais tarde.",
          "title_main": "Não foi possível carregar suas notificações",
          "title_settings": "Não foi possível carregar suas configurações de notificação"
        },
        "preferences_update_error": "Não foi possível atualizar suas configurações de notificação. Tente novamente mais tarde."
      },
      "expand": "Expandir",
      "mainTitle": "Notificações",
      "markAllAsReadLabel": "Marcar tudo como lido",
      "markAsReadLabel": "Marcar como lido",
      "notificationBellAriaLabel": "centro de notificações",
      "settings": {
        "accountSettings": "Configurações da conta",
        "accountSettingsPrompt": "Você pode alterar isso em {<settingsLink>}",
        "currentEmail": "Seu email atual para notificações é {<email>}",
        "header": "Configurações de notificação",
        "subtitle": "Os alertas/lembretes do sistema não serão afetados pelas configurações de notificação.",
        "title": "Selecione como deseja ser notificado."
      },
      "unreadLabel": "Não lido"
    }
  }
];